import { useContext, useEffect, useState } from "react";
import { Empty, Radio, Segmented } from "antd";
import { OperationConstant, ShiftingConstant } from "../../../core/_constant";
import ShiftingOperationsList from "./ShiftingOperationsList";
import HatchCoverList from "./HatchCoverList";
import { WaitingTimeList } from "./WaitingTimeList";
import { useLocation, useNavigate, useSearchParams } from "react-router";
import { OperationContext } from "../CreateOperation";

const ALL_TYPE = ShiftingConstant.SHIFTING_TYPE?.map((item) => {
  return {
    ...item,
    component:
      item?.value === ShiftingConstant.SHIFTING_ID ? (
        <ShiftingOperationsList />
      ) : item?.value === ShiftingConstant.HATCH_COVER_ID ? (
        <HatchCoverList />
      ) : (
        <WaitingTimeList />
      ),
  };
});

export const Shifting = () => {
  const { initialValue } = useContext(OperationContext);

  const [searchMovement, setSearchMovement] = useSearchParams();
  const typeFromURL = parseInt(searchMovement.get("movment") || "");

  const ALL_MOVEMENT = [
    initialValue?.debarkationMovement?.id && {
      label: OperationConstant.LANDING_LABEL,
      value: initialValue?.debarkationMovement?.id,
    },
    initialValue?.embarkationMovement?.id && {
      label: OperationConstant.BOARDING_LABEL,
      value: initialValue?.embarkationMovement?.id,
    },
  ].filter(Boolean);

  useEffect(() => {
    const currentMovement = searchMovement.get("movment")
    if (!currentMovement || currentMovement === "undefined") {
      const newMovementParam = new URLSearchParams(searchMovement);
      newMovementParam.set("movment", ALL_MOVEMENT[0]?.value.toString());
      setSearchMovement(newMovementParam);
    }
  }, [initialValue]);

  const handleChangeMovement = (value: any) => {
    const newMovementParam = new URLSearchParams(searchMovement);
    newMovementParam.set("movment", value?.toString());
    let reachedType = false;
    const keysToDelete: any = [];

    newMovementParam.forEach((_, key) => {
      if (reachedType) keysToDelete.push(key);
      if (key === "movment") reachedType = true;
    });

    keysToDelete.forEach((key: any) => newMovementParam.delete(key));
    setSearchMovement(newMovementParam);
  };

  /*   const activeComponent =
    ALL_MOVEMENT.find((item) => item?.value === typeFromURL)?.component ||
    ALL_MOVEMENT[0]?.component; */

  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const typeFromUrl = queryParams.get("type");
  const defaultType = typeFromUrl || ShiftingConstant.SHIFTING_ID;
  const defaultLabel =
    ALL_TYPE.find((item) => item.value === defaultType)?.label ||
    ShiftingConstant.SHIFTING_LABEL;

  const [selectedType, setSelectedType] = useState(defaultType);
  const [selectedTypeLabel, setSelectedTypeLabel] = useState<
    string | undefined
  >(defaultLabel);

  useEffect(() => {
    if (typeFromUrl && typeFromUrl !== selectedType) {
      setSelectedType(typeFromUrl);
      const label =
        ALL_TYPE.find((item) => item.value === typeFromUrl)?.label ||
        ShiftingConstant.SHIFTING_LABEL;
      setSelectedTypeLabel(label);
    }
  }, [typeFromUrl]);

  const handleChangeType = (key: any) => {
    const selected = ALL_TYPE.find((item) => item.value === key);
    if (typeof selected?.component === "string") {
      window.location.href = selected.component;
    } else {
      setSelectedType(key);
      setSelectedTypeLabel(selected?.label);
      const currentParams = new URLSearchParams(location.search);
      currentParams.set("type", key);
      navigate(`?${currentParams.toString()}`, { replace: true });
    }
  };

  const currentComponent = ALL_TYPE.find(
    (item) => item.value === selectedType
  )?.component;

  // const menuProps = {
  //   items: ALL_TYPE.map((item) => ({
  //     key: item.value,
  //     label: item.label,
  //   })),
  //   onClick: ({ key }: any) => handleChangeType(key),
  // };

  return (
    <>
      <Radio.Group
        onChange={(e) => handleChangeMovement(e.target.value)}
        value={typeFromURL}
        optionType="button"
        buttonStyle="solid"
      >
        {ALL_MOVEMENT.map((item) => (
          <Radio key={item?.value} value={item?.value}>
            {item?.label}
          </Radio>
        ))}
      </Radio.Group>

      <div
        style={{
          overflowX: "auto",
          overflowY: "auto",
          position: "relative",
          width: "100%",
          maxWidth: "100%",
          marginTop: 16,
        }}
      >
        {/* <Dropdown.Button menu={menuProps} onClick={() => {}} style={{ marginBottom: 16, paddingLeft: 6 }} placement="bottom">
          {selectedTypeLabel}
        </Dropdown.Button> */}

        <div className="d-flex justify-content-center">
          <Segmented
            style={{ marginBottom: 20 }}
            options={ALL_TYPE}
            value={selectedType}
            onChange={(e) => handleChangeType(e)}
          />
          {/* <Radio.Group
            onChange={(e) => handleChangeType(e.target.value)}
            value={selectedType}
            optionType="button"
            buttonStyle="outline"
            style={{ marginBottom: 20 }}
          >
            {ALL_TYPE.map((item) => {
              const isSelected = selectedType === item.value;
              return (
                <Radio.Button
                  key={item.value}
                  value={item.value}
                  style={{
                    backgroundColor: "white",
                    color: isSelected ? "#1677ff" : "black",
                    borderColor: isSelected ? "#1677ff" : "#d9d9d9",
                  }}
                >
                  {item.label}
                </Radio.Button>
              );
            })}
          </Radio.Group> */}
        </div>

        {
          typeFromURL ? (
            <>
            {typeof currentComponent !== "string" && currentComponent}
            </>
          ) : (
            <Empty description="En attente de manifeste"/>
          )
        }
      </div>
    </>
  );
};
